import React from "react";

const ListIcon = () => {
  return (
    <div>
      <svg
        width="22"
        height="15"
        viewBox="0 0 22 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.22223 14.9565C0.87593 14.9565 0.585856 14.8382 0.352004 14.6017C0.118152 14.3652 0.000819029 14.0728 4.21455e-06 13.7246C-0.0008106 13.3764 0.116523 13.084 0.352004 12.8475C0.587486 12.611 0.877559 12.4927 1.22223 12.4927H20.7778C21.1241 12.4927 21.4146 12.611 21.6492 12.8475C21.8839 13.084 22.0008 13.3764 22 13.7246C21.9992 14.0728 21.8818 14.3656 21.648 14.603C21.4141 14.8403 21.1241 14.9582 20.7778 14.9565H1.22223ZM1.22223 8.7971C0.87593 8.7971 0.585856 8.67884 0.352004 8.44232C0.118152 8.20579 0.000819029 7.91343 4.21455e-06 7.56522C-0.0008106 7.217 0.116523 6.92464 0.352004 6.68811C0.587486 6.45159 0.877559 6.33333 1.22223 6.33333H20.7778C21.1241 6.33333 21.4146 6.45159 21.6492 6.68811C21.8839 6.92464 22.0008 7.217 22 7.56522C21.9992 7.91343 21.8818 8.2062 21.648 8.44355C21.4141 8.68089 21.1241 8.79874 20.7778 8.7971H1.22223ZM1.22223 2.63768C0.87593 2.63768 0.585856 2.51942 0.352004 2.2829C0.118152 2.04638 0.000819029 1.75401 4.21455e-06 1.4058C-0.0008106 1.05759 0.116523 0.765223 0.352004 0.528702C0.587486 0.292181 0.877559 0.17392 1.22223 0.17392H20.7778C21.1241 0.17392 21.4146 0.292181 21.6492 0.528702C21.8839 0.765223 22.0008 1.05759 22 1.4058C21.9992 1.75401 21.8818 2.04679 21.648 2.28413C21.4141 2.52148 21.1241 2.63933 20.7778 2.63768H11H1.22223Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export default ListIcon;
